import request from "./request";
import router from "../router";

function get(url, params) {
  const response = request.service.get(url, { params: { ...params } });
  return response;
}

function post(url, data) {
  return request.service.post(url, { ...data });
}

function put(url, data) {
  return request.service.put(url, { ...data });
}

function del(url, params) {
  return request.service.delete(url, { params: { ...params } });
}

export function upload(data) {
  return request.service.post(
    process.env.VUE_APP_API_BASE_URL + "/api/Oss/UploadAvatar",
    { ...data }
  );
}

export { get, post, put, del };
